/** Fired after the org databases list changes (create/delete); Sidebar listens to refetch. */
export const DATABASES_LIST_CHANGED_EVENT = 'veilstream:databases-changed'

export function notifyDatabasesListChanged(): void {
  window.dispatchEvent(new CustomEvent(DATABASES_LIST_CHANGED_EVENT))
}
